module.exports = __webpack_public_path__ + "static/winds-2-21ea66e56ad53131ce6572a6521625ff.jpg";